import { KeyValue } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IClient, IUserDto } from 'src/app/core/models';
import {
  AuthService,
  ClientService,
  ToastService,
  TokenService,
  UserService,
} from 'src/app/core/services';

@Component({
  selector: 'ic-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  public profileForm: FormGroup;
  public suspendForm: FormGroup;
  public formErrors: any = {};
  public clientConfig: IClient;
  public selectedTab = 1;

  constructor(
    private readonly fb: FormBuilder,
    private readonly userService: UserService,
    private readonly toastService: ToastService,
    private readonly clientService: ClientService,
    private readonly tokenService: TokenService,
    private readonly authService: AuthService,
    private readonly router: Router
  ) {
    this.clientConfig = this.clientService.currentClientValue;
  }

  ngOnInit(): void {
    this.clientService.currentClient.subscribe((client) => {
      this.clientConfig = client;
    });
    this.getProfile();

    this.profileForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(50)]],
      email: [
        {
          value: ''
        },
        [Validators.required, Validators.maxLength(50), Validators.email],
      ],
      mobile: [
        {
          value: '',
          disabled: true,
        },
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
    });

    this.suspendForm = this.fb.group({
      password: ['', [Validators.required, Validators.maxLength(30)]],
      description: ['', Validators.maxLength(50)],
      confirm: ['', [Validators.requiredTrue]],
    });

    // This forces validation.
    Object.keys(this.profileForm.controls).forEach((key) => {
      this.profileForm.get(key).markAsTouched();
    });

    this.profileForm.valueChanges.subscribe((changes) => {
      Object.keys(changes).forEach((controlName) => {
        const control = this.profileForm.controls[controlName];
        this.formErrors[controlName] =
          (control.touched || control.dirty) && control.errors ? 'error' : null;
      });
    });

    Object.keys(this.suspendForm.controls).forEach((key) => {
      this.suspendForm.get(key).markAsTouched();
    });

    this.suspendForm.valueChanges.subscribe((changes) => {
      Object.keys(changes).forEach((controlName) => {
        const control = this.suspendForm.controls[controlName];
        this.formErrors[controlName] =
          (control.touched || control.dirty) && control.errors ? 'error' : null;
      });
    });
  }

  get fc() {
    return this.profileForm.controls;
  }

  get fcs() {
    return this.suspendForm.controls;
  }

  isNumber(evt: any) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  }

  getProfile(): void {
    this.userService.getUser().subscribe(
      (data) => {
        this.profileForm.patchValue(data);
      },
      (err) => {
        this.toastService.showError(err.exceptionMessage || err.message);
      }
    );
  }

  updateProfile(): void {
    if (!this.profileForm.dirty) {
      this.toastService.showSuccess('Profile updated successfully');
      return;
    }
    const model: IUserDto = {
      ...this.profileForm.value,
    };
    model.restaurantId = this.clientConfig.restaurantId;

    this.userService.updateUser(model).subscribe(
      (data) => {
        if(data.isSuccess) {
        this.toastService.showSuccess('Profile updated successfully');
        this.authService.updateUser(model);
        this.profileForm.markAsPristine();
        } else {
          this.toastService.showError(data.errors[0]);
        }
      },
      (err) => {
        this.toastService.showError(err.exceptionMessage || err.message);
      }
    );
  }

  deleteProfile(): void {
    const model: KeyValue<string, string> = {
      key: this.suspendForm.get('password').value,
      value: this.suspendForm.get('description').value,
    };
    this.authService.deleteAccount(model).subscribe(
      (data) => {
        if (data.isSuccess) {
          this.authService.logOut();
          this.router.navigate(['/home']);
          this.toastService.showSuccess(
            'Your account has been deleted successfully'
          );
        } else {
          this.toastService.showError(data.errors[0]);
        }
      },
      (err) => {
        this.toastService.showError(err.exceptionMessage || err.message);
      }
    );
  }
}
